module.exports = __webpack_public_path__ + "static/media/dedicated-linux-server-es.e65a348c.png";